export default __webpack_public_path__ + "static/media/Nameplate_Customizable_Text.e0df8bb7.jpg";